// extracted by mini-css-extract-plugin
module.exports = {"base":"projectsSelector_base__3cKoD","name":"projectsSelector_name__1NiCD"};